import moment from "moment";
import {
  DATE_AND_TIME_FOR_TABLE_FORMAT,
  MONTH_DAY_YEAR_WHILE_MONTH_IN_STRING_FORMAT,
} from "configs/AppConfig";
import { Tag } from "antd";
import { LAST_CHECK_TIME } from "constants/AuthConstant";

export const changeDateFormatAndReturnNewDate = (oldDate, newFormat) => {
  const newDate = moment(oldDate, "YYYYMMDDhhmmss").format(newFormat);
  //const newDate = moment(oldDate).format(newFormat);
  return newDate;
};

export const initializeTheMomentStartOfWeek = () => {
  moment.updateLocale("en", {
    week: {
      dow: 1, // Monday is the first day of the week.
    },
  });
};

export function calculateAge(date, pageType = "order") {
  let dateString =
    pageType === "result"
      ? date.substring(0, 4) +
        "-" +
        date.substring(4, 6) +
        "-" +
        date.substring(6, 8)
      : date;
  // Parse the input date string
  var birthDate = new Date(dateString);
  // Get the current date
  var currentDate = new Date();

  // Calculate the difference in years and months
  var years = currentDate.getFullYear() - birthDate.getFullYear();
  var months = currentDate.getMonth() - birthDate.getMonth();

  // Adjust for negative months
  if (months < 0) {
    years--;
    months += 12;
  }

  // Display the age in the desired format
  // if (years > 0) {
  //   return <Tag color="blue">{years}Y</Tag>;
  // } else {
  //   return <Tag color="blue">{months}M</Tag>;
  // }

  if (years > 0) {
    return `${years}Y`;
  } else {
    return `${months}M`;
  }
}

export const convertDateFormatToAge = (webAgeOrDateOfBirth) => {
  var birthDate = new Date(webAgeOrDateOfBirth);
  var currentDate = new Date();
  var years = currentDate.getFullYear() - birthDate.getFullYear();
  return years;
};

export const convertAnyInputToDateFormat = (value) => {
  try {
    // Check if the input is a date without dashes or slashes (e.g., 1281990 or 12081990)
    // if (/^\d{6,8}$/.test(value)) {
    //   let day, month, year;
    //   if (value.length === 6) {
    //     day = value.substring(0, 1);
    //     month = value.substring(1, 2);
    //     year = value.substring(2, 6);
    //   }

    //   if (value.length === 7) {
    //     if (value.startsWith("0")) {
    //       const firstPart = parseInt(value.substring(0, 2));
    //       const secondPart = parseInt(value.substring(2, 3));
    //       const thirdPart = parseInt(value.substring(3, 7));

    //       day = firstPart <= 31 && secondPart <= 12 ? firstPart : secondPart;
    //       month = secondPart <= 12 ? secondPart : firstPart;
    //       year = thirdPart;
    //     } else {
    //       const firstPart = parseInt(value.substring(0, 1));
    //       const secondPart = parseInt(value.substring(1, 3));
    //       const thirdPart = parseInt(value.substring(3, 7));

    //       day = firstPart <= 31 && secondPart <= 12 ? firstPart : secondPart;
    //       month = secondPart <= 12 ? secondPart : firstPart;
    //       year = thirdPart;
    //     }
    //   }

    //   if (value.length === 8) {
    //     const firstPart = parseInt(value.substring(0, 2));
    //     const secondPart = parseInt(value.substring(2, 4));
    //     const thirdPart = parseInt(value.substring(4, 8));

    //     day = firstPart <= 31 && secondPart <= 12 ? firstPart : secondPart;
    //     month = secondPart <= 12 ? secondPart : firstPart;
    //     year = thirdPart;
    //   }

    //   const formattedDate = `${day}/${month}/${year}`;
    //   return ["Date", formattedDate];
    // }
    if (isNaN(value)) {
      let suffix = value.charAt(value.length - 1).toLowerCase();
      let formattedDOB;

      if (suffix === "d") {
        let actualDay = value.substring(0, value.length - 1);
        const birthDay = new Date().getDate() - actualDay;
        const dob = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          birthDay + 1
        );
        formattedDOB = dob.toISOString().split("T")[0];
      } else if (suffix === "m") {
        let actualMonth = value.substring(0, value.length - 1);
        const birthMonth = new Date().getMonth() - actualMonth;
        const dob = new Date(new Date().getFullYear(), birthMonth, 2);
        formattedDOB = dob.toISOString().split("T")[0];
      } else if (suffix === "y") {
        let actualYear = value.substring(0, value.length - 1);
        const currentYear = new Date().getFullYear();
        const birthYear = currentYear - actualYear;
        const dob = new Date(birthYear, 1, 1); // Assuming January 1st as the birthdate
        formattedDOB = dob.toISOString().split("T")[0];
      } else {
        return ["NaNButValidValue", value];
      }

      return ["NaN", formattedDOB];
    }
    //if incase the age is in number
    else {
      const currentYear = new Date().getFullYear();
      const birthYear = currentYear - parseInt(value);
      const dob = new Date(birthYear, 1, 1); // Assuming January 1st as the birthdate
      let formattedDOB = dob.toISOString().split("T")[0];
      return ["Digit", formattedDOB];
    }
  } catch (error) {
    return ["something", "error"];
  }
};

export const saveCurrentTimeToLocalStorage = () => {
  const now = new Date().toISOString(); // Save as ISO string for portability
  localStorage.setItem(LAST_CHECK_TIME, now);
};

export const isMoreThan12HoursPassed = () => {
  try {
    const savedTime = localStorage.getItem(LAST_CHECK_TIME);
    if (savedTime == null) {
      return false;
    } else {
      const savedDate = new Date(savedTime);
      const now = new Date();
      const diffInMs = now - savedDate;
      const twelveHoursInMs = 12 * 60 * 60 * 1000;
      // const twelveHoursInMs = 1 * 60;
      return diffInMs > twelveHoursInMs;
    }
  } catch (error) {
    return false;
  }
};
